import styled, { css } from 'styled-components';

import { mediaQuery } from '@catalyze/ui';

export const FormLine = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-flow: column;
    ${mediaQuery(
        2,
        css`
            flex-flow: row;
        `
    )}
`;

export const InputContainer = styled.div`
    width: 100%;
`;
